import { render, staticRenderFns } from "./PersonGroupModal.vue?vue&type=template&id=f0aa5228&"
import script from "./PersonGroupModal.vue?vue&type=script&lang=js&"
export * from "./PersonGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0aa5228')) {
      api.createRecord('f0aa5228', component.options)
    } else {
      api.reload('f0aa5228', component.options)
    }
    module.hot.accept("./PersonGroupModal.vue?vue&type=template&id=f0aa5228&", function () {
      api.rerender('f0aa5228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/Person/modules/PersonGroupModal.vue"
export default component.exports